import React from "react";
import propTypes from "prop-types"
import { InspectedArea } from "../../../logic/api";
import splatImage from '../../../assets/splat.jpg' ;

export const InspectionImage:React.FunctionComponent<{inspectedArea: InspectedArea, url:string}> = (props)=>{
    return <div 
    style={{paddingLeft:10,paddingRight:10,paddingBottom:10, cursor:"pointer",textAlign:"center"}}
 onClick={()=>{
     window.open(props.url,"_blank")
 }}
>
 <div style={{position:"relative"}}>
 <img style={{width:"100%", display:"inline-block",borderRadius:10,}} src={props.url}/>
<div style={{width:200, zoom:0.7, position:"absolute", right:20,top:20,borderRadius:10,overflow:"hidden", border:"solid 2px white",backgroundColor:"white"}}>
    <div style={{position:"relative",width:"100%",height:"100%"}}>
    <img style={{width:"100%", borderRadius:10}} src={splatImage}/>
    {props.inspectedArea.gridReference==0 && (<div style={{position:"absolute",left:0,top:0,height:80,width:66,backgroundColor:"red", borderRadius:5,opacity:0.5}}></div>)}
    {props.inspectedArea.gridReference==1 && (<div style={{position:"absolute",left:66,top:0,height:80,width:66,backgroundColor:"red",borderRadius:5,opacity:0.5}}></div>)}
    {props.inspectedArea.gridReference==2 && (<div style={{position:"absolute",left:136,top:0,height:80,width:66,backgroundColor:"red",borderRadius:5,opacity:0.5}}></div>)}
    {props.inspectedArea.gridReference==3 && (<div style={{position:"absolute",left:0,top:80,height:50,width:66,backgroundColor:"red",borderRadius:5,opacity:0.5}}></div>)}
    {props.inspectedArea.gridReference==4 && (<div style={{position:"absolute",left:66,top:80,height:50,width:66,backgroundColor:"red",borderRadius:5,opacity:0.5}}></div>)}
    {props.inspectedArea.gridReference==5 && (<div style={{position:"absolute",left:136,top:80,height:50,width:66,backgroundColor:"red",borderRadius:5,opacity:0.5}}></div>)}
    {props.inspectedArea.gridReference==6 && (<div style={{position:"absolute",left:0,top:130,height:50,width:66,backgroundColor:"red",borderRadius:5,opacity:0.5}}></div>)}
    {props.inspectedArea.gridReference==7 && (<div style={{position:"absolute",left:66,top:130,height:50,width:66,backgroundColor:"red",borderRadius:5,opacity:0.5}}></div>)}
    {props.inspectedArea.gridReference==8 && (<div style={{position:"absolute",left:136,top:130,height:50,width:66,backgroundColor:"red",borderRadius:5,opacity:0.5}}></div>)}
    {props.inspectedArea.gridReference==9 && (<div style={{position:"absolute",left:0,top:175,height:80,width:66,backgroundColor:"red", borderRadius:5,opacity:0.5}}></div>)}
    {props.inspectedArea.gridReference==10 && (<div style={{position:"absolute",left:66,top:175,height:80,width:66,backgroundColor:"red",borderRadius:5,opacity:0.5}}></div>)}
    {props.inspectedArea.gridReference==11 && (<div style={{position:"absolute",left:136,top:175,height:80,width:66,backgroundColor:"red",borderRadius:5,opacity:0.5}}></div>)}
    </div>
</div>

</div>  



</div>;
}

InspectionImage.propTypes ={
    inspectedArea: propTypes.any.isRequired,
    url: propTypes.any.isRequired,
}